import React from 'react';
import { useTranslation } from 'react-i18next';

const VideoBanner = () => {
  const { t } = useTranslation('common');
  return (
    <div className="relative w-full h-[70svh] min-h-[420px] max-h-[720px] md:h-[680px] md:max-h-none overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        poster="https://res.cloudinary.com/dc6xthiol/image/upload/v1779737488/20220514_133501_cenkvy.jpg"
      >
        <source
          src="https://res.cloudinary.com/dc6xthiol/video/upload/v1777537126/BannerHM2_tjgtyp.mp4"
          type="video/mp4"
        />
        <img
          src="https://res.cloudinary.com/dc6xthiol/image/upload/v1779737488/20220514_133501_cenkvy.jpg"
          alt={t('home.videoAlt')}
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
    </div>
  );
};

export default VideoBanner;